<template>
    <section id='login' class='login'>
        <teleport to="body">
            <div v-if=state.isLoading>
                <base-spinner/>
            </div>
        </teleport>
        <div class='contents'>
            <div class='mark_section'>
                <img src='image/mark.svg' />
            </div>
            <p class='txt'>관리자 로그인</p>
            <div class='input_section'>
                <input class='id' v-model='state.form.user_id' type='text' placeholder='아이디'>
                <input class='pw' v-model='state.form.user_password' type='password' placeholder='비밀번호' @keyup.enter='loginUser()'>
                <input class='submit' @click='loginUser()' type='submit' value='로그인'>
            </div>
        </div>
    </section>
</template>

<script>
//import * as authApi from '@/api/auth'
import { reactive } from "vue";
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
    setup() {
        const router = useRouter()
        const store = useStore()

        const state = reactive({
            form: {
                user_id: "",
                user_password: "",
            },
            isLoading: false
        });
        const loginUser = async() => {
            const args = {
                userId: state.form.user_id,
                password: state.form.user_password
            }
            state.isLoading = true;

            try {
                await store.dispatch('login/requestLogin', args)
                state.isLoading = false;
                router.replace('/dashboard');
            } catch (error) {
                state.isLoading = false;
            }
        }
        return { state, loginUser,}
    }
}
</script>

<style scoped>
input {
    border: none;
}

.login {
    height:100vh;
    display:flex;
    align-items: center;
    justify-content: center;
    margin-left: 0 !important;
    width: 100% !important;
}

.contents {
    /* width: 33%; */
    height: 540px;
    width: 583px;
    border-radius: 50px;
    background-color: #607D8B;
    padding: 60px 120px 60px 120px;
    display: flex;
    flex-direction: column;
}

.contents img {
    width: 140px;
    height: 140px;
}

.mark_section {
    display: flex;
    justify-content: center;
    align-items: center;
}

.txt {
    font-size: 28px;
    text-align: center;
    color: #ECEFF1;
}

.input_section {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 8px;
}

.input_section>.id,
.pw {
    width: 335px;
    height: 44px;
    padding: 10px 14px 10px 14px;
    border-radius: 8px;
    border: 0px, 0px, 1px, 0px;
    background-color: #CFD8DC;
    font-size: 16px;
}

.input_section>input::placeholder {
    color: #78909C;
}

.input_section>.submit {
    width: 343px;
    height: 42px;
    padding: 10px 18px 10px 18px;
    border-radius: 30px;
    border: 1px;
    background-color: #CFD8DC;
    font-size: 16px;
    color: #78909C
}
</style>